import { Component, OnInit, ViewChild, EventEmitter } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";
import { LocalDataService } from "../../../../../../modules/shared/services/local-data.service";
import { SessionService } from "../../../../../../modules/shared/services/session-service";
import { CatalogService } from "../../../../../../modules/shared/services/catalog.service";
import * as moment from 'moment';
import 'moment-timezone';
import { DatePipe } from '@angular/common';


@Component({
    selector: "filter-config",
    templateUrl: "./filter-config.view.html",
    providers: []
})
export class FilterConfigView implements OnInit {
    standardFields: any = [];
    standardFieldLabels: any = [];
    customFields: any = [];
    customFieldLabels: any = [];
    standardTextFields: Array<string> = ["name", "code", "description", "abstract"];
    placementValues = ["Top", "Side"];
    selectionMechanisms = [{ label: "Checkbox List", id: 1 }, { label: "Radio List", id: 2 }];
    presetOptionsSelected: any = 0;
    selectedFilters = [];

    expansionStyles = [{ label: "Chevron", id: 1 }, { label: "Chevron Circle", id: 2 }];
    timezoneArr = [];
    dates = [];
    times = [];
    tracks = [];
    types = [];
    levels = [];
    locations = [];
    tags = [];
    industries = [];
    jobFunctions = [];
    productGoals = [];
    options = {};
    public selectedDates = [];
    public selectedTimes = [];
    public selectedTracks = [];
    public selectedTypes = [];
    public selectedLevels = [];
    public selectedLocations = [];
    public selectedTags = [];
    public selectedIndustries = [];
    public selectedJobFunctions = [];
    public selectedProductGoals = [];
    public selectedOptions: any = {};
    public preSelectedTracks = [];
 	public preSelectedTypes = [];
 	public preSelectedLevels = [];
 	public preSelectedLocations = [];
 	public preSelectedTags = [];
 	public preSelectedIndustries = [];
 	public preSelectedJobFunctions = [];
 	public preSelectedProductGoals = [];
 	public preSelectedOptions: any = {};
 	public selectedPresetFilterOptions: any = {};
    showCustomFieldOptions: Boolean = false;
    public filterlabel: String = '';
    blankLabel: string = '(Blank)';
    defaultTimeZoneKey: string;

    constructor(
        public sharedService: SharedService,
        private localDataService: LocalDataService,
        private sessionService: SessionService,
        private catalogService: CatalogService,
        private datePipe: DatePipe
    ) {
        if (!this.sharedService.filterSetup.hasOwnProperty("showMysessionsFilter")) {
            this.sharedService.filterSetup.showMysessionsFilter = true;
        }

        if (!this.sharedService.filterSetup.hasOwnProperty("showTimezoneFilter")) {
            this.sharedService.filterSetup.showTimezoneFilter = true;
        }

        if (!this.sharedService.filterSetup.hasOwnProperty("showSessionDateRangePicker")) {
            this.sharedService.filterSetup.showSessionDateRangePicker = false;
        }

        if (!this.sharedService.filterSetup.hasOwnProperty("selectTimezone")) {
            this.sharedService.filterSetup.selectTimezone = 'browser_timezone';
            this.sharedService.filterSetup.isDefaultTimezone = true;
        }

        if (this.sharedService.event.eventDelivery === 'In Person' && this.sharedService.filterSetup.isDefaultTimezone == true) {
            this.sharedService.filterSetup.selectTimezone = 'event_timezone';
        }

        if (this.sharedService.filterSetup.hasOwnProperty("selectedDates")) {
            this.sharedService.filterSetup.selectedDates.forEach((element) => {
                this.selectedDates.push(element);
            });
        }

        if (this.sharedService.filterSetup.hasOwnProperty("selectedTimes")) {


            this.sharedService.filterSetup.selectedTimes.forEach((element) => {
                this.selectedTimes.push(element);
            });
        }

        if (this.sharedService.filterSetup.hasOwnProperty("selectedTracks")) {
            this.sharedService.filterSetup.selectedTracks.forEach((element) => {
                this.selectedTracks.push(element);
            });
        }

        if (this.sharedService.filterSetup.hasOwnProperty("selectedTypes")) {
            this.sharedService.filterSetup.selectedTypes.forEach((element) => {
                this.selectedTypes.push(element);
            });
        }

        if (this.sharedService.filterSetup.hasOwnProperty("selectedLevels")) {
            this.sharedService.filterSetup.selectedLevels.forEach((element) => {
                this.selectedLevels.push(element);
            });
        }

        if (this.sharedService.filterSetup.hasOwnProperty("selectedLocations")) {
            this.sharedService.filterSetup.selectedLocations.forEach((element) => {
                this.selectedLocations.push(element);
            });
        }

        if (this.sharedService.filterSetup.hasOwnProperty("selectedTags")) {
            this.sharedService.filterSetup.selectedTags.forEach((element) => {
                this.selectedTags.push(element);
            });
        }

        if (this.sharedService.filterSetup.hasOwnProperty("selectedIndustries")) {
            this.sharedService.filterSetup.selectedIndustries.forEach((element) => {
                this.selectedIndustries.push(element);
            });
        }

        if (this.sharedService.filterSetup.hasOwnProperty("selectedJobFunctions")) {
            this.sharedService.filterSetup.selectedJobFunctions.forEach((element) => {
                this.selectedJobFunctions.push(element);
            });
        }

        if (this.sharedService.filterSetup.hasOwnProperty("selectedProductGoals")) {
            this.sharedService.filterSetup.selectedProductGoals.forEach((element) => {
                this.selectedProductGoals.push(element);
            });
        }

        this.localDataService.getJSON("filter-standardFields.json").subscribe((data) => {
            if (data != null) {
                this.standardFields = data;
                this.standardFields.forEach((element) => {
                    this.standardFieldLabels[element.code] = element.label;
                });
            }
        });
        this.customFields = [];
        this.sharedService.sessionEnumCustomFields.forEach((element) => {
            this.customFields.push({
                code: "customField_" + element.id,
                label: element.name
            });
            this.customFieldLabels["customField_" + element.id] = element.name;
            this.options["customField_" + element.id] = [];
            element.options.sort((a, b) => a.order - b.order)
            element.options.forEach((option) => {
                this.options["customField_" + element.id].push({
                    id: option.id,
                    label: option.name
                });
            });
            this.options["customField_" + element.id].push({
                id: null,
                label: this.blankLabel
            });
        });

        if (this.sharedService.filterSetup.hasOwnProperty("selectedOptions")) {
            this.sharedService.sessionEnumCustomFields.forEach((ele) => {
                if(this.sharedService.filterSetup.selectedOptions.hasOwnProperty(["customField_" + ele.id])) {
                    this.selectedOptions["customField_" + ele.id] = [];
                    this.sharedService.filterSetup.selectedOptions["customField_" + ele.id].forEach((element) => {
                        this.selectedOptions["customField_" + ele.id].push(element);
                    });
                }
            });
        }

        this.sharedService.sessionTrack.forEach(element => {
            this.tracks.push({ 'label': element.trackName, 'id': element.id });
        });
        this.tracks.push({ 'label': this.blankLabel, 'id': null });

        this.sharedService.sessionTypes.forEach(element => {
            this.types.push({ 'label': element.sessionType, 'id': element.id });
        });
        this.types.push({ 'label': this.blankLabel, 'id': null });

        this.sharedService.sessionLevels.forEach(element => {
            this.levels.push({ 'label': element.levelName, 'id': element.id });
        });
        this.levels.push({ 'label': this.blankLabel, 'id': null });

        this.sharedService.sessionLocations.forEach(element => {
            this.locations.push({ 'label': element.name, 'id': element.id });
        });
        this.locations.push({ 'label': this.blankLabel, 'id': null });

        this.sharedService.sessionTags.forEach(element => {
            this.tags.push({ 'label': element.label, 'id': element.id });
        });
        this.tags.push({ 'label': this.blankLabel, 'id': null });

        this.sharedService.industries.forEach(element => {
            this.industries.push({ 'label': element.name, 'id': element.id });
        });
        this.industries.push({ 'label': this.blankLabel, 'id': null });

        this.sharedService.jobFunctions.forEach(element => {
            this.jobFunctions.push({ 'label': element.name, 'id': element.id });
        });
        this.jobFunctions.push({ 'label': this.blankLabel, 'id': null });

        // Add api calling to collect distinct product goals and loaded into local list
        this.sharedService.productGoals.forEach(element => {
            this.productGoals.push({ 'label': element, 'id': element });
        });
        this.productGoals.push({ 'label': this.blankLabel, 'id': null });

        this.defaultTimeZoneKey = this.sharedService.timezonekey
        moment.tz.setDefault(this.defaultTimeZoneKey);

        this.getdates();

        this.sharedService.sessionEnumCustomFields.forEach((element) => {
            if(this.sharedService.filterSetup.customFields.indexOf("customField_" + element.id) >= 0 &&
            (Object.keys(this.selectedOptions).length === 0 || !this.selectedOptions["customField_" + element.id])) {
                this.selectedOptions["customField_" + element.id] = []
                element.options.forEach(ele => {
                    this.selectedOptions["customField_" + element.id].push(ele.id)
                });
            } 
            
            if(this.sharedService.filterSetup.customFields.indexOf("customField_" + element.id) < 0) {
                this.selectedOptions["customField_" + element.id] = [];
            }
        })
        this.showCustomFieldOptions = true;
    }

    ngOnInit() {
        this.timezoneArr = [{ label: "Browser Timezone", id: 'browser_timezone' }, { label: "Event Timezone " + this.sharedService.event.timeZoneDisplayName, id: 'event_timezone' }];
        if(Object.keys(this.sharedService.editSaveFilter).length > 0) {
            this.selectedPresetFilterOptions = JSON.parse(this.sharedService.editSaveFilter.filterConfig);
            this.presetOptionsSelected = Object.keys(this.selectedPresetFilterOptions).length;
            Object.keys(this.selectedPresetFilterOptions).forEach(element => {
                if(!element.includes("customField_")) {
                    let type;
                    if(element == 'level') {
                        type = 'sessionLevel'
                    } else if(element == 'type') {
                        type = 'sessionType'
                    } else if(element == 'selectedTime') {
                        type = 'sessionTime';
                    } else if(element == 'selectedDate') {
                        type = 'sessionDate';
                    } else {
                        type = element;
                    }
                    this.selectedFilters.push({ 'type': 'standardFields', 'field': type });
                } else {
                    
                    this.selectedFilters.push({ 'type': 'customFields', 'field': element });
                }
            });
        }
        this.beautifyCSS();
    }

    beautifyCSS() {
        this.sharedService.filterSetup.styling = this.sharedService.beautifyCSS(this.sharedService.filterSetup.styling);
    }

    setDisplayOptions(value, type) {
        if (this.sharedService.filterSetup[type].indexOf(value.code) >= 0) {
            this.sharedService.filterSetup[type].splice(this.sharedService.filterSetup[type].indexOf(value.code), 1);
            let index = -1;
            for (let i = 0; i < this.sharedService.filterSetup.selectedFields.length; i++) {
                if (
                    this.sharedService.filterSetup.selectedFields[i].type == type &&
                    this.sharedService.filterSetup.selectedFields[i].field == value.code
                ) {
                    index = i;
                    break;
                }
            }
            if (index >= 0) {
                this.sharedService.filterSetup.selectedFields.splice(index, 1);
            }
            if (value.code === "sessionDate") {
                this.selectedDates = [];
                this.sharedService.filterSetup["selectedDates"] = this.selectedDates;
            }

            if (value.code === "sessionTime") {
                this.selectedTimes = [];
                this.sharedService.filterSetup["selectedTimes"] = this.selectedTimes;
            }

            if (value.code === "track") {
                this.selectedTracks = [];
                this.sharedService.filterSetup["selectedTracks"] = this.selectedTracks;
            }

            if (value.code === "sessionType") {
                this.selectedTypes = [];
                this.sharedService.filterSetup["selectedTypes"] = this.selectedTypes;
            }

            if (value.code === "sessionLevel") {
                this.selectedLevels = [];
                this.sharedService.filterSetup["selectedLevels"] = this.selectedLevels;
            }

            if (value.code === "location") {
                this.selectedLocations = [];
                this.sharedService.filterSetup["selectedLocations"] = this.selectedLocations;
            }

            if (value.code === "tag") {
                this.selectedTags = [];
                this.sharedService.filterSetup["selectedTags"] = this.selectedTags;
            }

            if (value.code === "industry") {
                this.selectedIndustries = [];
                this.sharedService.filterSetup["selectedIndustries"] = this.selectedIndustries;
            }

            if (value.code === "jobFunction") {
                this.selectedJobFunctions = [];
                this.sharedService.filterSetup["selectedJobFunctions"] = this.selectedJobFunctions;
            }

            if (value.code === "productGoal") {
                this.selectedProductGoals = [];
                this.sharedService.filterSetup["selectedProductGoals"] = this.selectedProductGoals;
            }

            if(type == 'customFields') {
                this.selectedOptions[value.code] = [];
                this.sharedService.filterSetup.selectedOptions[value.code] = this.selectedOptions[value.code];
            }
        } else {
            this.sharedService.filterSetup[type].push(value.code);
            this.sharedService.filterSetup.selectedFields.push({
                field: value.code,
                type: type
            });
            if (value.code === "sessionDate" && this.selectedDates.length <= 0) {
                this.dates.forEach((element) => {
                    this.selectedDates.push(element.id);
                });
                this.sharedService.filterSetup["selectedDates"] = this.selectedDates;
            }

            if(this.sharedService.filterSetup.showSessionDateRangePicker) {
                this.sharedService.filterSetup.showSessionDateRangePicker = false;
            }

            if (value.code === "sessionTime" && this.selectedTimes.length <= 0) {
                this.times.forEach((element) => {
                    this.selectedTimes.push(element.label);
                });
                this.sharedService.filterSetup["selectedTimes"] = this.selectedTimes;
            }

            if (value.code === "track" && this.selectedTracks.length <= 0) {
                this.tracks.forEach((element) => {
                    this.selectedTracks.push(element.id);
                });
                this.sharedService.filterSetup["selectedTracks"] = this.selectedTracks;
            }

            if (value.code === "sessionType" && this.selectedTypes.length <= 0) {
                this.types.forEach((element) => {
                    this.selectedTypes.push(element.id);
                });
                this.sharedService.filterSetup["selectedTypes"] = this.selectedTypes;
            }

            if (value.code === "sessionLevel" && this.selectedLevels.length <= 0) {
                this.levels.forEach((element) => {
                    this.selectedLevels.push(element.id);
                });
                this.sharedService.filterSetup["selectedLevels"] = this.selectedLevels;
            }

            if (value.code === "location" && this.selectedLocations.length <= 0) {
                this.locations.forEach((element) => {
                    this.selectedLocations.push(element.id);
                });
                this.sharedService.filterSetup["selectedLocations"] = this.selectedLocations;
            }

            if (value.code === "tag" && this.selectedTags.length <= 0) {
                this.tags.forEach((element) => {
                    this.selectedTags.push(element.id);
                });
                this.sharedService.filterSetup["selectedTags"] = this.selectedTags;
            }

            if (value.code === "industry" && this.selectedIndustries.length <= 0) {
                this.industries.forEach((element) => {
                    this.selectedIndustries.push(element.id);
                });
                this.sharedService.filterSetup["selectedIndustries"] = this.selectedIndustries;
            }

            if (value.code === "jobFunction" && this.selectedJobFunctions.length <= 0) {
                this.jobFunctions.forEach((element) => {
                    this.selectedJobFunctions.push(element.id);
                });
                this.sharedService.filterSetup["selectedJobFunctions"] = this.selectedJobFunctions;
            }

            if (value.code === "productGoal" && this.selectedProductGoals.length <= 0) {
                this.productGoals.forEach((element) => {
                    this.selectedProductGoals.push(element.id);
                });
                this.sharedService.filterSetup["selectedProductGoals"] = this.selectedProductGoals;
            }

            if (type === "customFields" && this.selectedOptions[value.code].length <= 0) {
                this.options[value.code].forEach((element) => {
                    this.selectedOptions[value.code].push(element.id);
                });
                this.sharedService.filterSetup["selectedOptions"] = this.selectedOptions;
            }
        }
    }

    setOptions(code, type) {
        if(code == 'sessionLevel') {
            code = 'level';
        } else if(code == 'sessionType') {
            code = 'type';
        } else if(code == 'sessionTime') {
            code = 'selectedTime';
        } else if(code == 'sessionDate') {
            code = 'selectedDate';
        }
        
        if(type == 'standardFields') {
            if (code === "selectedDate") {
                this.selectedPresetFilterOptions["selectedDate"] = this.selectedDates;
            }

            if (code === "selectedTime") {
                this.selectedPresetFilterOptions["selectedTime"] = this.selectedTimes;
            }

            if (code === "track" && this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == this.tracks.length) {
                this.selectedPresetFilterOptions["track"] = [];
            } else if(code === "track" && (!this.selectedPresetFilterOptions[code] || (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length != this.tracks.length))) {
                this.selectedPresetFilterOptions["track"] = [];
                this.tracks.forEach(element => {
                    this.selectedPresetFilterOptions["track"].push(element.id);
                });
            }

            if (code === "type" && this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == this.types.length) {
                this.selectedPresetFilterOptions["type"] = [];
            } else if(code === "type" && (!this.selectedPresetFilterOptions[code] || (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length != this.types.length))) {
                this.selectedPresetFilterOptions["type"] = [];
                this.types.forEach(element => {
                    this.selectedPresetFilterOptions["type"].push(element.id);
                });
            }

            if (code === "level" && this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == this.levels.length) {
                this.selectedPresetFilterOptions["level"] = [];
            } else if(code === "level" && (!this.selectedPresetFilterOptions[code] || (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length != this.levels.length))) {
                this.selectedPresetFilterOptions["level"] = [];
                this.levels.forEach(element => {
                    this.selectedPresetFilterOptions["level"].push(element.id);
                });
            }

            if (code === "location" && this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == this.locations.length) {
                this.selectedPresetFilterOptions["location"] = [];
            } else if(code === "location" && (!this.selectedPresetFilterOptions[code] || (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length != this.locations.length))) {
                this.selectedPresetFilterOptions["location"] = [];
                this.locations.forEach(element => {
                    this.selectedPresetFilterOptions["location"].push(element.id);
                });
            }

            if (code === "tag" && this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == this.tags.length) {
                this.selectedPresetFilterOptions["tag"] = [];
            } else if(code === "tag" && (!this.selectedPresetFilterOptions[code] || (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length != this.tags.length))) {
                this.selectedPresetFilterOptions["tag"] = [];
                this.tags.forEach(element => {
                    this.selectedPresetFilterOptions["tag"].push(element.id);
                });
            }

            if (code === "industry" && this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == this.industries.length) {
                this.selectedPresetFilterOptions["industry"] = [];
            } else if(code === "industry" && (!this.selectedPresetFilterOptions[code] || (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length != this.industries.length))) {
                this.selectedPresetFilterOptions["industry"] = [];
                this.industries.forEach(element => {
                    this.selectedPresetFilterOptions["industry"].push(element.id);
                });
            }

            if (code === "jobFunction" && this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == this.jobFunctions.length) {
                this.selectedPresetFilterOptions["jobFunction"] = [];
            } else if(code === "jobFunction" && (!this.selectedPresetFilterOptions[code] || (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length != this.jobFunctions.length))) {
                this.selectedPresetFilterOptions["jobFunction"] = [];
                this.jobFunctions.forEach(element => {
                    this.selectedPresetFilterOptions["jobFunction"].push(element.id);
                });
            }

            if (code === "productGoal" && this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == this.productGoals.length) {
                this.selectedPresetFilterOptions["productGoal"] = [];
            } else if(code === "productGoal" && (!this.selectedPresetFilterOptions[code] || (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length != this.productGoals.length))) {
                this.selectedPresetFilterOptions["productGoal"] = [];
                this.productGoals.forEach(element => {
                    this.selectedPresetFilterOptions["productGoal"].push(element.id);
                });
            }
        }
            

        if(type == 'customFields') {
            let temp = code.split('_');
            let id = temp[1] 
            let obj = this.sharedService.sessionEnumCustomFields.find(x => x.id == id);
            if(this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == obj.options.length + 1) {
                this.selectedPresetFilterOptions[code] = [];
            } else if ((!this.selectedPresetFilterOptions[code] || (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length != obj.options.length + 1))) {
                this.selectedPresetFilterOptions[code] = [];
                obj.options.forEach(element => {
                    this.selectedPresetFilterOptions[code].push(element.id);
                });
                this.selectedPresetFilterOptions[code].push(null);
            }
        }

        this.sharedService.preSetFilterOptions = this.selectedPresetFilterOptions;
        this.presetOptionsSelected = Object.keys(this.sharedService.preSetFilterOptions).length;

        this.getValue(code);
    }

    getValue(code) {
        if(code == 'sessionLevel') {
            code = 'level';
        } else if(code == 'sessionType') {
            code = 'type';
        }
        if(code == 'track') {
            return (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == this.tracks.length) ? true : false;
        }

        if(code == 'type') {
            return (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == this.types.length) ? true : false;
        }

        if(code == 'level') {
            return (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == this.levels.length) ? true : false;
        }

        if(code == 'location') {
            return (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == this.locations.length) ? true : false;
        }
        
        if(code == 'tag') {
            return (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == this.tags.length) ? true : false;
        }

        if(code == 'industry') {
            return (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == this.industries.length) ? true : false;
        }

        if(code == 'jobFunction') {
            return (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == this.jobFunctions.length) ? true : false;
        }

        if(code == 'productGoal') {
            return (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == this.productGoals.length) ? true : false;
        }

        if(code.includes('customField_')) {
            let temp = code.split('_');
            let id = temp[1] 
            let obj = this.sharedService.sessionEnumCustomFields.find(x => x.id == id);
            return (this.selectedPresetFilterOptions[code] && this.selectedPresetFilterOptions[code].length == obj.options.length + 1) ? true : false; 
        }
    }

    selectDate(date) {
        let type = "standardFields";
        let value = { code: "sessionDate" };
        if (this.selectedDates.indexOf(date.id) >= 0) {
            this.selectedDates.splice(this.selectedDates.indexOf(date.id), 1);
            this.sharedService.filterSetup["selectedDates"] = this.selectedDates;
            if (this.selectedDates.length <= 0) {
                this.setDisplayOptions(value, type);
            }
        } else {
            this.selectedDates.push(date.id);
            this.sharedService.filterSetup["selectedDates"] = this.selectedDates;
            if (this.sharedService.filterSetup[type].indexOf("sessionDate") < 0) {
                this.setDisplayOptions(value, type);
            }
        }
    }

    checkIfExists(type) {
        if(type == 'level') {
            type = 'sessionLevel'
        } else if(type == 'type') {
            type = 'sessionType'
        } else if(type == 'selectedTime') {
            type = 'sessionTime';
        } else if(type == 'selectedDate') {
            type = 'sessionDate';
        }
        if(!this.sharedService.isEditSaveFilter) {
            let index = this.sharedService.filterSetup['selectedFields'].findIndex( (e:any) => e.field == type);
            return index >= 0 ? true : false;
        } else {
            let index = this.sharedService.filterSetup['selectedFields'].findIndex( (e:any) => e.field == type);
            let temp = JSON.parse(this.sharedService.editSaveFilter.filterConfig);
            if(type == 'sessionLevel') {
                type = 'level'
            } else if(type == 'sessionType') {
                type = 'type'
            } else if(type == 'sessionTime') {
                type = 'selectedTime';
            } else if(type == 'sessionDate') {
                type = 'selectedDate';
            }
            return (index > -1 || (temp[type] && temp[type].length > 0)) ? true : false;
        }
    }

    checkToDisabled(type) {
        if(this.sharedService.isEditSaveFilter) {
            let index = this.sharedService.filterSetup['selectedFields'].findIndex( (e:any) => e.field == type);
            return index > -1 ? false : true;
        }
    }

    selectTime(time) {
        let type = "standardFields";
        let value = { code: "sessionTime" };
        if (this.selectedTimes.indexOf(time.label) >= 0) {
            this.selectedTimes.splice(this.selectedTimes.indexOf(time.label), 1);
            this.sharedService.filterSetup["selectedTimes"] = this.selectedTimes;
            if (this.selectedTimes.length <= 0) {
                this.setDisplayOptions(value, type);
            }
        } else {
            this.selectedTimes.push(time.label);
            this.sharedService.filterSetup["selectedTimes"] = this.selectedTimes;
            if (this.sharedService.filterSetup[type].indexOf("sessionTime") < 0) {
                this.setDisplayOptions(value, type);
            }
        }
    }

    selectTrack(track) {
        let type = "standardFields";
        let value = { code: "track" };
        if (this.selectedTracks.indexOf(track.id) >= 0) {
            this.selectedTracks.splice(this.selectedTracks.indexOf(track.id), 1);
            this.sharedService.filterSetup["selectedTracks"] = this.selectedTracks;
            if (this.selectedTracks.length <= 0) {
                this.setDisplayOptions(value, type);
            }
        } else {
            this.selectedTracks.push(track.id);
            this.sharedService.filterSetup["selectedTracks"] = this.selectedTracks;
            if (this.sharedService.filterSetup[type].indexOf("track") < 0) {
                this.setDisplayOptions(value, type);
            }
        }
    }

    selectType(sessionType) {
        let type = "standardFields";
        let value = { code: "sessionType" };
        if (this.selectedTypes.indexOf(sessionType.id) >= 0) {
            this.selectedTypes.splice(this.selectedTypes.indexOf(sessionType.id), 1);
            this.sharedService.filterSetup["selectedTypes"] = this.selectedTypes;
            if (this.selectedTypes.length <= 0) {
                this.setDisplayOptions(value, type);
            }
        } else {
            this.selectedTypes.push(sessionType.id);
            this.sharedService.filterSetup["selectedTypes"] = this.selectedTypes;
            if (this.sharedService.filterSetup[type].indexOf("sessionType") < 0) {
                this.setDisplayOptions(value, type);
            }
        }
    }

    selectLevel(level) {
        let type = "standardFields";
        let value = { code: "sessionLevel" };
        if (this.selectedLevels.indexOf(level.id) >= 0) {
            this.selectedLevels.splice(this.selectedLevels.indexOf(level.id), 1);
            this.sharedService.filterSetup["selectedLevels"] = this.selectedLevels;
            if (this.selectedLevels.length <= 0) {
                this.setDisplayOptions(value, type);
            }
        } else {
            this.selectedLevels.push(level.id);
            this.sharedService.filterSetup["selectedLevels"] = this.selectedLevels;
            if (this.sharedService.filterSetup[type].indexOf("sessionLevel") < 0) {
                this.setDisplayOptions(value, type);
            }
        }
    }

    selectLocation(location) {
        let type = "standardFields";
        let value = { code: "location" };
        if (this.selectedLocations.indexOf(location.id) >= 0) {
            this.selectedLocations.splice(this.selectedLocations.indexOf(location.id), 1);
            this.sharedService.filterSetup["selectedLocations"] = this.selectedLocations;
            if (this.selectedLocations.length <= 0) {
                this.setDisplayOptions(value, type);
            }
        } else {
            this.selectedLocations.push(location.id);
            this.sharedService.filterSetup["selectedLocations"] = this.selectedLocations;
            if (this.sharedService.filterSetup[type].indexOf("location") < 0) {
                this.setDisplayOptions(value, type);
            }
        }
    }

    selectTag(tag) {
        let type = "standardFields";
        let value = { code: "tag" };
        if (this.selectedTags.indexOf(tag.id) >= 0) {
            this.selectedTags.splice(this.selectedTags.indexOf(tag.id), 1);
            this.sharedService.filterSetup["selectedTags"] = this.selectedTags;
            if (this.selectedTags.length <= 0) {
                this.setDisplayOptions(value, type);
            }
        } else {
            this.selectedTags.push(tag.id);
            this.sharedService.filterSetup["selectedTags"] = this.selectedTags;
            if (this.sharedService.filterSetup[type].indexOf("tag") < 0) {
                this.setDisplayOptions(value, type);
            }
        }
    }

    selectIndustry(industry) {
        let type = "standardFields";
        let value = { code: "industry" };
        if (this.selectedIndustries.indexOf(industry.id) >= 0) {
            this.selectedIndustries.splice(this.selectedIndustries.indexOf(industry.id), 1);
            this.sharedService.filterSetup["selectedIndustries"] = this.selectedIndustries;
            if (this.selectedIndustries.length <= 0) {
                this.setDisplayOptions(value, type);
            }
        } else {
            this.selectedIndustries.push(industry.id);
            this.sharedService.filterSetup["selectedIndustries"] = this.selectedIndustries;
            if (this.sharedService.filterSetup[type].indexOf("industry") < 0) {
                this.setDisplayOptions(value, type);
            }
        }
    }

    selectJobFunction(job) {
        let type = "standardFields";
        let value = { code: "jobFunction" };
        if (this.selectedJobFunctions.indexOf(job.id) >= 0) {
            this.selectedJobFunctions.splice(this.selectedJobFunctions.indexOf(job.id), 1);
            this.sharedService.filterSetup["selectedJobFunctions"] = this.selectedJobFunctions;
            if (this.selectedJobFunctions.length <= 0) {
                this.setDisplayOptions(value, type);
            }
        } else {
            this.selectedJobFunctions.push(job.id);
            this.sharedService.filterSetup["selectedJobFunctions"] = this.selectedJobFunctions;
            if (this.sharedService.filterSetup[type].indexOf("jobFunction") < 0) {
                this.setDisplayOptions(value, type);
            }
        }
    }

    selectProductGoal(item) {
        let type = "standardFields";
        let value = { code: "productGoal" };
        if (this.selectedProductGoals.indexOf(item.id) >= 0) {
            this.selectedProductGoals.splice(this.selectedProductGoals.indexOf(item.id), 1);
            this.sharedService.filterSetup["selectedProductGoals"] = this.selectedProductGoals;
            if (this.selectedProductGoals.length <= 0) {
                this.setDisplayOptions(value, type);
            }
        } else {
            this.selectedProductGoals.push(item.id);
            this.sharedService.filterSetup["selectedProductGoals"] = this.selectedProductGoals;
            if (this.sharedService.filterSetup[type].indexOf("productGoal") < 0) {
                this.setDisplayOptions(value, type);
            }
        }
    }


    selectCustomFieldValues(field, value) {
        let type = "customFields";
        if (this.selectedOptions[field.code].indexOf(value.id) >= 0) {
            this.selectedOptions[field.code].splice(this.selectedOptions[field.code].indexOf(value.id), 1);
            this.sharedService.filterSetup["selectedOptions"] = this.selectedOptions;
            if (this.selectedOptions[field.code].length <= 0) {
                this.setDisplayOptions(field, type);
            }
        } else {
            this.selectedOptions[field.code].push(value.id);
            this.sharedService.filterSetup["selectedOptions"] = this.selectedOptions;
            if (this.sharedService.filterSetup[type].indexOf(field.code) < 0) {
                this.setDisplayOptions(field, type);
            }
        }
    }

    removeFilter(index, field) {
        this.selectedFilters.splice(index, 1);
        let type;
        if(field.field == 'sessionLevel') {
            type = 'level'
        } else if(field.field == 'sessionType') {
            type = 'type'
        } else if(field.field == 'sessionTime') {
            type = 'selectedTime';
        } else if(field.field == 'sessionDate') {
            type = 'selectedDate';
        } else {
            type = field.field;
        }
        delete this.selectedPresetFilterOptions[type];
        this.sharedService.preSetFilterOptions = this.selectedPresetFilterOptions;
        this.presetOptionsSelected = Object.keys(this.sharedService.preSetFilterOptions).length;
    }

    removeDisplayOptions(index, field) {
        this.sharedService.filterSetup[field.type].splice(
            this.sharedService.filterSetup[field.type].indexOf(field.field),
            1
        );
        this.sharedService.filterSetup.selectedFields.splice(index, 1);

        if(field.type == 'customFields') {
            this.selectedOptions[field.field] = [];
            this.sharedService.filterSetup['selectedOptions'][field.field] = [];
        }

        if (field.field === "sessionDate") {
            this.selectedDates = [];
            this.sharedService.filterSetup["selectedDates"] = this.selectedDates;
        }

        if (field.field === "sessionTime") {
            this.selectedTimes = [];
            this.sharedService.filterSetup["selectedTimes"] = this.selectedTimes;
        }

        if (field.field === "track") {
            this.selectedTracks = [];
            this.sharedService.filterSetup["selectedTracks"] = this.selectedTracks;
        }

        if (field.field === "sessionType") {
            this.selectedTypes = [];
            this.sharedService.filterSetup["selectedTypes"] = this.selectedTypes;
        }

        if (field.field === "sessionLevel") {
            this.selectedLevels = [];
            this.sharedService.filterSetup["selectedLevels"] = this.selectedLevels;
        }

        if (field.field === "location") {
            this.selectedLocations = [];
            this.sharedService.filterSetup["selectedLocations"] = this.selectedLocations;
        }

        if (field.field === "tag") {
            this.selectedTags = [];
            this.sharedService.filterSetup["selectedTags"] = this.selectedTags;
        }

        if (field.field === "industry") {
            this.selectedIndustries = [];
            this.sharedService.filterSetup["selectedIndustries"] = this.selectedIndustries;
        }

        if (field.field === "jobFunction") {
            this.selectedJobFunctions = [];
            this.sharedService.filterSetup["selectedJobFunctions"] = this.selectedJobFunctions;
        }

        if (field.field === "productGoal") {
            this.selectedProductGoals = [];
            this.sharedService.filterSetup["selectedProductGoals"] = this.selectedProductGoals;
        }
    }

    getdates() {
        let dateFormat = 'EEEE, MMMM dd';
        this.sessionService.getSessionInstanceDates().subscribe((data) => {
            data.body["dateList"].forEach((date) => {
                this.dates.push({
                    id: date,
                    label: this.datePipe.transform(moment(date).format(this.sharedService.dateFormat), dateFormat)
                });
            });

            data.body["timeList"].forEach((date) => {
                this.times.push({
                    id: date,
                    label: date
                });
            });

            let temp = [];
            this.dates.forEach(element => {
                if(temp.findIndex(item => item.label === element.label) == -1) {
                    temp.push(element);
                }
            });
            this.dates = temp;
            this.sharedService.dates = this.dates;
           
            if (this.sharedService.filterSetup.hasOwnProperty("selectedDates")) {
                let temp = [];
                this.sharedService.filterSetup.selectedDates.forEach(element => {
                    if(this.dates.findIndex(obj => {
                        return obj.id == element
                      }) > -1) {
                        temp.push(element);
                    }
                });
                this.sharedService.filterSetup.selectedDates = temp;
                this.selectedDates = temp;
            }
            
            if (
                this.sharedService.filterSetup.standardFields.indexOf("sessionDate") >= 0 &&
                this.selectedDates.length == 0
            ) {
                this.dates.forEach((element) => {
                    this.selectedDates.push(element.id);
                });
            }

            if (
                this.sharedService.filterSetup.standardFields.indexOf("sessionTime") >= 0 &&
                this.selectedTimes.length == 0
            ) {
                this.times.forEach((element) => {
                    this.selectedTimes.push(element.label);
                });
            }

            let isTrackSelected = this.sharedService.filterSetup.selectedFields.some((o) => o.field === 'track' && o.type === 'standardFields');
            if(isTrackSelected && this.selectedTracks.length === 0) {
                this.tracks.forEach(element => {
                    this.selectedTracks.push(element.id);
                });
            }

            if (
                this.sharedService.filterSetup.standardFields.indexOf("sessionType") >= 0 &&
                this.selectedTypes.length == 0
            ) {
                this.types.forEach((element) => {
                    this.selectedTypes.push(element.id);
                });
            }

            if (
                this.sharedService.filterSetup.standardFields.indexOf("sessionLevel") >= 0 &&
                this.selectedLevels.length == 0
            ) {
                this.levels.forEach((element) => {
                    this.selectedLevels.push(element.id);
                });
            }

            if (
                this.sharedService.filterSetup.standardFields.indexOf("location") >= 0 &&
                this.selectedLocations.length == 0
            ) {
                this.locations.forEach((element) => {
                    this.selectedLocations.push(element.id);
                });
            }
            
            if (
                this.sharedService.filterSetup.standardFields.indexOf("tag") >= 0 &&
                this.selectedTags.length == 0
            ) {
                this.tags.forEach((element) => {
                    this.selectedTags.push(element.id);
                });
            }

            if (
                this.sharedService.filterSetup.standardFields.indexOf("industry") >= 0 &&
                this.selectedIndustries.length == 0
            ) {
                this.industries.forEach((element) => {
                    this.selectedIndustries.push(element.id);
                });
            }

            if (
                this.sharedService.filterSetup.standardFields.indexOf("jobFunction") >= 0 &&
                this.selectedJobFunctions.length == 0
            ) {
                this.jobFunctions.forEach((element) => {
                    this.selectedJobFunctions.push(element.id);
                });
            }

            if (
                this.sharedService.filterSetup.standardFields.indexOf("productGoal") >= 0 &&
                this.selectedProductGoals.length == 0
            ) {
                this.productGoals.forEach((element) => {
                    this.selectedProductGoals.push(element.id);
                });
            }

        });
    }

    toggleHTMLEnable(e,type) {
        this.sharedService.filterSetup[type] = !this.sharedService.filterSetup[type];
        if(type === 'showSessionDateRangePicker') {
            let index1 = this.sharedService.filterSetup.standardFields.findIndex(x => x === "sessionDate");
            let index2 = this.sharedService.filterSetup.selectedFields.findIndex(x => x.field ==="sessionDate");
            if(index1>0 && index2>0) {
                this.setDisplayOptions({code: "sessionDate", label: "Session Date"},'standardFields');
            }
        }

        if(this.sharedService.filterSetup['showSessionDateRangePicker']) {
            this.sharedService.tabConfig.isTabsEnabled = false
        }
    }

    selectFilterOption (type, value) {
        if(!this.selectedPresetFilterOptions.hasOwnProperty(type)) {
            this.selectedPresetFilterOptions[type] = [];
            this.selectedPresetFilterOptions[type].push(value);
        } else if (!this.selectedPresetFilterOptions[type].includes(value)) {
            if(type == 'selectedDate' || type == 'selectedTime') {
                this.selectedPresetFilterOptions[type] = [];
            this.selectedPresetFilterOptions[type].push(value);
            } else {
                this.selectedPresetFilterOptions[type].push(value);
            }
        } else {
            this.selectedPresetFilterOptions[type].splice(this.selectedPresetFilterOptions[type].indexOf(value), 1);

            if(this.selectedPresetFilterOptions[type].length == 0) {
                delete this.selectedPresetFilterOptions[type];
            }
        }
        this.sharedService.preSetFilterOptions = this.selectedPresetFilterOptions;
        this.presetOptionsSelected = Object.keys(this.sharedService.preSetFilterOptions).length;
        this.selectedFilters = [];
        Object.keys(this.selectedPresetFilterOptions).forEach(element => {
                if(!element.includes("customField_")) {
                    let type;
                    if(element == 'level') {
                        type = 'sessionLevel'
                    } else if(element == 'type') {
                        type = 'sessionType'
                    } else if(element == 'selectedTime') {
                        type = 'sessionTime';
                    } else if(element == 'selectedDate') {
                        type = 'sessionDate';
                    } else {
                        type = element;
                    }
                    this.selectedFilters.push({ 'type': 'standardFields', 'field': type });
                } else {
                    this.selectedFilters.push({ 'type': 'customFields', 'field': element });
                }
        });
    }
}
